import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import '../styles/auth.css';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn, error } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  useEffect(() => {
    const reason = (location.state as { reason?: string } | null)?.reason;
    if (reason === 'not_admin') {
      setLocalError('Bu panele sadece admin kullanıcılar erişebilir.');
    }
  }, [location.state]);

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      setLocalError(null);
      setLoading(true);
      try {
        await signIn(email.trim(), password.trim());
        const redirectTo = (location.state as { from?: Location } | null)?.from?.pathname ?? '/';
        navigate(redirectTo, { replace: true });
      } catch (err: unknown) {
        setLocalError(err instanceof Error ? err.message : 'Giriş yapılamadı');
      } finally {
        setLoading(false);
      }
    },
    [email, password, signIn, navigate, location.state]
  );

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <header className="auth-header">
          <span className="auth-logo">L</span>
          <div>
            <h1>Lido Yönetim</h1>
            <p>Platformu yönetmek için giriş yapın.</p>
          </div>
        </header>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label>
            <span>E-posta</span>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="admin@lido.app"
            />
          </label>
          <label>
            <span>Parola</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
            />
          </label>

          {(localError || error) && (
            <p role="alert" className="auth-error">
            {localError ?? error}
            </p>
          )}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Yönetim paneline gir'}
          </button>
        </form>
        <footer className="auth-footer">
          <p>Bu panel yalnızca restoran yöneticileri ve platform personeli içindir.</p>
        </footer>
      </div>
    </div>
  );
}
